import Main from './Main'
import MainLearningCenter from './BlogMain'

export { Main, MainLearningCenter }
